exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.json-editor[data-v-03d4ca30]{\n  height: 100%;\n  position: relative;\n}\n.json-editor[data-v-03d4ca30] .CodeMirror {\n  height: auto;\n  min-height: 300px;\n}\n.json-editor[data-v-03d4ca30] .CodeMirror-scroll{\n  min-height: 300px;\n}\n.json-editor[data-v-03d4ca30] .cm-s-rubyblue span.cm-string {\n  color: #F08047;\n}\n", ""]);

// exports
